import React, { useEffect, useState } from 'react'
import { Avatar, Card, Col, Row, Tooltip } from 'antd'
import './style.css'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { FaCalendarAlt, FaChevronLeft } from 'react-icons/fa';
import useWindowSize from '../../../../../config/hooks/utility/useWindowSize';
import { FaPhoneAlt } from "react-icons/fa";
import Button from '../../../../../components/FormElements/Button';
import { FaCircleCheck } from 'react-icons/fa6';
import { LuMapPin } from 'react-icons/lu';
import { getAllServices, getBookingStatus, getCurrentLocation, getDistanceByCoordinates, getEllipsedString, getFormattedDateTime, getInitials, getLastLayerServices, getServicesList } from '../../../../../config/utils';
import Modal from '../../../../../components/Modal';
import DynamicForm from '../../../../../components/FormElements/DynamicForm'
import successCheck from '../../../../../assets/images/check.png'
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import Prompt from '../../../../../components/Prompt';
import useJobApi from '../../../../../config/hooks/api/booking/job/useJobApi';
import dayjs from 'dayjs';
import { setAppLoading, setError, setMessage } from '../../../../../store/common/generalSlice';
import { bookingDecisions } from '../../../../../config/utils/constants';
import CarRegistrationNumberPlate from '../../../../../components/Elements/CarRegistrationNumberPlate';
import useBookingApi from '../../../../../config/hooks/api/booking/useBookingApi';
import { filtersDataFormatter } from '../../../../../config/utils/FiltersDataFormatter';
import AddQuote from '../../../Quotation/AddQuote';
import { fetchProfileData } from '../../../../../store/common/settingSlice';
import { setChatModal, setSelectedChatMemberData } from '../../../../../store/common/chatSlice';
import DisputeForm from '../../../../../components/DisputeForm';
import ChatModal from '../../../../Common/Chats/ChatModal';
import { adminActionIdentifier } from '../../../../../config/utils/StatusIdentifier';
import useVisibilityCheck from '../../../../../config/hooks/utility/useVisibilityCheck';
import { useMutation } from 'react-query';
import axiosInstance from '../../../../../config/api';
import { BsCalendarCheckFill } from 'react-icons/bs';
import { calculateCommission } from '../../../../../config/utils/calculateCommission';
import CustomPriceField from '../../../../../components/CustomPriceField';
import { finalPriceAfterExtractingCommission } from '../../../../../config/utils/finalPriceExtractingCommission';

const JobDetails = () => {

    const dispatch = useDispatch()
    const { jobId } = useParams()
    const location = useLocation()
    const { width } = useWindowSize();
    const { getProviderJobRequestDetails, acceptRejectJobRequest, completeJobRequest } = useJobApi()
    const { getUserBookingDetails } = useBookingApi()
    const userId = JSON.parse(localStorage.getItem('user'))?.id
    const { profileData } = useSelector(state => state?.setting);
    const user = useSelector(state => state?.auth?.loggedInUser);

    const [jobDetails, setJobDetails] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState(null)
    const [prompt, setPrompt] = useState(false)
    const [promptMsg, setPromptMsg] = useState('')
    const [userLocation, setUserLocation] = useState(null)
    const [refresh, setRefresh] = useState(0)
    const [qoutesServices, setQuotesServices] = useState(null);
    const [spProfileData, setSpProfileData] = useState(null);

    const [disputeModal, setDisputeModal] = useState(false);
    const [disputedAgainstId, setDisputedAgainstId] = useState(null);
    const [displayQuotesServices, setDisplayQuotesServices] = useState(null);

    const [servicesLength, setServicesLength] = useState(0);

    console.log(jobDetails, "jobDetails")

    const getJobRequestDetails = async (jobId) => {
        try {
            dispatch(setAppLoading(true))
            const response = await getProviderJobRequestDetails(jobId)
            if (response) {
                setJobDetails(response?.data?.bookingDetails)
                setServicesLength(response?.data?.bookingDetails?.services?.length)
                dispatch(setAppLoading(false))
            }

        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const handleJobOfferAsSp = async (decisionId) => {
        try {
            if (user && user?.type.toLowerCase() == 'service provider') {
                setShowModal(true)
                if (decisionId == 1) {
                    setModalType('quoteInput')
                }
                else {
                    setModalType('rejectReasonInput')
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSPQuoteFormSuccess = async () => {
        try {
            dispatch(setAppLoading(true))

            // setShowSPQuoteSuccessAlert(true)
            setShowModal(true)
            setModalType('successAlert')

            const response = await acceptRejectJobRequest(jobId, {
                status: 3,
                reasonOfRejection: ''
            })
            if (response) {
                setRefresh(prev => ++prev)

                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const handleQuoteAmendSuccess = async () => {
        dispatch(setAppLoading(true))

        setShowModal(false)
        setModalType(null)
        setRefresh(prev => ++prev)

        dispatch(setAppLoading(false))
    }


    const closeJobPrompt = () => {
        setPromptMsg('Are you sure you want to close this job?')
        setPrompt(true)
    }


    const handleJobAmendment = () => {
        setShowModal(true)
        setModalType('amendJobInput')
    }

    /*
    const handleCloseJobPromptResponse = async (resp) => {
        try {
            if (resp) {
                dispatch(setAppLoading(true))

                const response = await completeJobRequest(jobDetails?.id)
                if (response) {
                    setPrompt(false)
                    setRefresh(prev => ++prev)

                    dispatch(setAppLoading(false))
                }
            }
            else {
                setPrompt(false)
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }
    */

    const handleCloseJobPromptResponse = async (resp) => {
        if (!resp) {
            setPrompt(false)
            return
        }
        try {
            dispatch(setAppLoading(true))
            await completeJobRequest(jobDetails?.id)
            setPrompt(false)
            setRefresh(prev => ++prev)
            dispatch(setMessage('Job closed successfully!'))
        } catch (error) {
            console.log(error)
        } finally {
            dispatch(setAppLoading(false))
        }
    }

    const handleBookingRejection = () => {
        setShowModal(false)
        setModalType(null)
        setRefresh(prev => ++prev)
    }

    const handleLocationPrompt = () => {
        setPromptMsg('Location can only be seen on mobile app')
        setPrompt(true)
    }

    const closeModal = () => {
        setShowModal(false)
        setModalType(null)
    }

    const handleSubmitQuoteForm = async (requestedServices, displayServices) => {
        if (spProfileData?.status && spProfileData?.status == 1) {
            try {
                // const bookingData = await getUserBookingDetails(jobDetails?.id);
                // const userQuotedServices = bookingData?.data?.bookingDetails?.selectedCategories;
                // if (userQuotedServices) {
                if (requestedServices && requestedServices.length) {
                    setQuotesServices(
                        // filtersDataFormatter(userQuotedServices)
                        requestedServices
                    );
                    setDisplayQuotesServices(displayServices);
                }
                // }
                setShowModal(true)
                setModalType('addQuote')
            }
            catch (error) {
                return false
            }
        }
        else {
            dispatch(setError('Business verification required.'))
        }
    }

    const handleAddQuoteSuccess = () => {
        setShowModal(false)
        setRefresh(prev => ++prev)
    }

    const formatDateByMonthName = (date) => {
        return date ? dayjs(date).format('D MMMM YYYY') : ''
    }


    // case to get profile of a sp to stop submitting a quote in case not verified by admin.
    useEffect(() => {
        dispatch(fetchProfileData())
    }, [])

    useEffect(() => {
        if (profileData) {
            setSpProfileData(profileData?.userDetail)
        }
    }, [profileData])

    // useEffect callbacks may only return undefined or a cleanup function. An async
    // callback returns a Promise instead, which React later tries to call as its
    // cleanup on unmount, causing "TypeError: destroy is not a function". Wrapping
    // the async work in an inner IIFE keeps the effect callback itself synchronous.
    useEffect(() => {
        (async () => {
            const userLocation = await getCurrentLocation()
            setUserLocation(userLocation)
        })()
    }, [])


    useEffect(() => {
        if (jobId) getJobRequestDetails(jobId)
    }, [jobId, refresh])


    const handleDisputePrompt = () => {
        setDisputedAgainstId(user?.id == jobDetails?.userId ? jobDetails?.serviceProviderId : jobDetails?.userId);
        setDisputeModal(true)
    }

    // after getting success on dispute calling for an updated data.
    const disputeFormHandler = (msg) => {
        if (msg == 'success') {
            setRefresh(prev => ++prev)
        }
    }

    // const getServicesList = (services) => {
    //     return (
    //         <ul className='m-0 p-0'>
    //             {services.map((service, index) => (
    //                 <li key={index}>{index + 1}. {service?.name}</li>
    //             ))}
    //         </ul>
    //     )
    // }
    const filteredQuotes =
        jobDetails?.quotes?.map(quote => quote)?.filter(
            quote => quote?.serviceProviderId != userId
        );
    let isAllowQoute = getBookingStatus(jobDetails?.status) === 'pending' || getBookingStatus(jobDetails?.status) === 'admin assigned' || getBookingStatus(jobDetails?.status) === 'responded' ? true : false;
    return (
        <React.Fragment>
            {user && user?.type?.toLowerCase() == 'service provider' ? (
                <Row>
                    <Col md={24} sm={24} xs={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                        <div className='flex justify-between items-center'>
                            <h5 className='heading-5 text-slate-600 font-semibold'>Details</h5>
                            <Link to='/' className='cursor-pointer flex items-center'>
                                <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                                <small className='ml-2 font-medium'>Back</small>
                            </Link>
                        </div>
                    </Col>
                    <Col span={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                        {jobDetails && Object.keys(jobDetails).length ? (
                            <Card
                                bordered={false}
                                className='mb-4 rounded-md'
                            >
                                <div className='flex sm:flex-row flex-col'>
                                    <div className='flex justify-center'>
                                        <Avatar
                                            className='border-2 p-1 mb-2 border-primary rounded-full'
                                            src={jobDetails?.serviceUser?.imageThumbUrl}
                                            alt="avatar"
                                            size={width > 767 ? 100 : 120}
                                        >
                                            {getInitials(jobDetails?.serviceUser?.fullName)}
                                        </Avatar>
                                    </div>
                                    <div className='sm:ml-2 w-full'>
                                        <div className='mb-4 ml-1'>
                                            <div className='flex sm:flex-row flex-col sm:justify-between justify-center items-center'>
                                                <div className='flex mr-2'>
                                                    <div className='sm:mr-4'>
                                                        <h3 className='heading-3 font-bold sm:mb-1 mb-2 sm:text-left text-center whitespace-nowrap'>
                                                            {
                                                                getEllipsedString(jobDetails?.serviceUser?.fullName, 15)
                                                            }
                                                        </h3>
                                                    </div>

                                                    {
                                                        jobDetails?.serviceUser?.badges &&
                                                            jobDetails?.serviceUser?.badges.length ? (
                                                            <div className='flex items-center sm:w-[50px]'>
                                                                {jobDetails?.serviceUser?.badges.map(badge => (
                                                                    <img
                                                                        key={badge?.id}
                                                                        src={badge?.imageUrl}
                                                                        alt={badge?.name}
                                                                        className='img-fluid badge w-[30px] inline-block mb-2 mr-2'
                                                                        onError={(e) => { e.target.style.display = 'none' }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        )
                                                            : ''}
                                                </div>

                                                <React.Fragment>
                                                    <div className='sm:hidden flex justify-center sm:justify-start mb-4'>
                                                        <div className='flex sm:flex-row flex-col'>
                                                            {
                                                                jobDetails?.services &&
                                                                    jobDetails?.services.length ?
                                                                    jobDetails?.services.slice(0, 3).map((service, index) => (
                                                                        <span key={service?.id}>
                                                                            <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                                <FaCircleCheck className='sm:hidden inline text-primary mr-2 bg-white rounded-full' />
                                                                                {service?.name}

                                                                                {index < jobDetails?.services.slice(0, 3).length - 1 &&
                                                                                    (<span className='mr-1'>,</span>)}
                                                                                {index == 2 && jobDetails?.services.length > 3 ?
                                                                                    (<span className='mr-1'>...</span>) : ''}
                                                                            </p>
                                                                        </span>
                                                                    ))
                                                                    : (
                                                                        <small className='text-xs'>Service not available</small>
                                                                    )}
                                                        </div>
                                                    </div>

                                                    {
                                                        (location && location?.pathname.toLowerCase().includes('myjobs')) &&
                                                            getBookingStatus(jobDetails?.status) != 'completed' &&
                                                            getBookingStatus(jobDetails?.status) != 'in-progress' ?
                                                            (
                                                                <div className='sm:hidden flex mb-4 sm:justify-start justify-center'>
                                                                    <small className='mr-6 text-[#00B517] font-semibold'>
                                                                        {
                                                                            `${jobDetails?.serviceProvider?.noOfBookingCompleted ?? 0} Job(s) Completed`
                                                                        }
                                                                    </small>
                                                                    <small className='text-[#FF1D6A] font-semibold'>
                                                                        ( {jobDetails?.distance?.toFixed(2) + ' Miles away'}
                                                                        <span className='ml-1'></span> )
                                                                    </small>
                                                                </div>
                                                            ) : ''}
                                                </React.Fragment>

                                                {
                                                    location && (!location?.pathname.toLowerCase().includes('myjobs') || jobDetails?.bookingType == 'DIRECT') && userId != jobDetails?.serviceProviderId && jobDetails?.quotes?.length == 0 ? (
                                                        <div className='flex sm:flex-row flex-col sm:justify-end sm:w-fit w-full'>
                                                            <div className='h-[40px] mr-2 mb-2 sm:w-fit w-full'>
                                                                <CarRegistrationNumberPlate regNumber={jobDetails?.vehicleRegistrationNo} />
                                                            </div>
                                                            <div className='mr-2 mb-2 py-[6px] px-2 sm:w-fit w-full bg-[#feedbf] rounded-md'>
                                                                <ChatModal selectedChatMemberData={jobDetails?.serviceUser} />
                                                            </div>
                                                            {
                                                                isAllowQoute &&
                                                                (<Button.Basic
                                                                    type="primary"
                                                                    size={"medium"}
                                                                    text={'Submit a Quote'}
                                                                    onClick={() => handleSubmitQuoteForm(jobDetails?.selectedCategories, jobDetails?.services)}
                                                                    disabled={false}
                                                                    className='bg-primary h-[40px] sm:w-fit w-full'
                                                                />)
                                                            }
                                                        </div>
                                                    ) : ''
                                                }
                                                {
                                                    location && (location?.pathname.toLowerCase().includes('myjobs') || jobDetails?.bookingType == 'DIRECT') &&
                                                        (getBookingStatus(jobDetails?.status) == 'in-progress' ||
                                                            getBookingStatus(jobDetails?.status) == 'completed') ?
                                                        (
                                                            <div className='flex sm:flex-wrap sm:flex-row flex-col pl-0 w-full items-center justify-end'>
                                                                <div className='h-[40px] sm:ml-2 ml-0 mb-2 sm:w-fit w-full'>
                                                                    <CarRegistrationNumberPlate regNumber={jobDetails?.vehicleRegistrationNo} />
                                                                </div>
                                                                {/* <div className='bg-[#FEEDBF] h-[42px] sm:ml-2 ml-0 mb-2 p-2 rounded-md sm:w-fit w-full'>
                                                                    <Link to={`tel:${jobDetails?.serviceUser?.phoneNo}`} className='block h-full'>
                                                                        <div className='flex justify-center items-center h-full'>
                                                                            <FaPhoneAlt className='text-2xl text-white bg-primary p-[5px] rounded-full' />
                                                                            <small className='text-xs ml-2 font-semibold'>Call</small>
                                                                        </div>
                                                                    </Link>
                                                                </div> */}
                                                                <div className='sm:ml-2 ml-0 mb-2 py-[6px] px-2 sm:w-fit w-full bg-[#feedbf] rounded-md'>
                                                                    <ChatModal selectedChatMemberData={jobDetails?.serviceUser} />
                                                                </div>

                                                                {/* case: inprogress */}
                                                                {/* sp closes an inprogress job */}
                                                                {
                                                                    getBookingStatus(jobDetails?.status) == 'in-progress' &&
                                                                    !jobDetails?.closedBySP &&
                                                                    jobDetails?.quotes?.some(quote => quote?.status === 'ACCEPTED' && quote?.serviceProviderId === userId) &&
                                                                    (
                                                                        <div className='flex sm:flex-row flex-col items-center justify-end sm:w-fit w-full'>
                                                                            <div className='mb-2 sm:ml-2 ml-0 sm:w-fit w-full'>
                                                                                <Button.Basic
                                                                                    onClick={closeJobPrompt}
                                                                                    disabled={jobDetails?.isDisputed}
                                                                                    icon={null}
                                                                                    loading={false}
                                                                                    type="primary"
                                                                                    size='small'
                                                                                    text='Close the Job'
                                                                                    className={`sm:w-fit w-full px-3 py-5 text-xs disabled-btn ${!jobDetails?.isDisputed && 'bg-primary'}`}
                                                                                />
                                                                            </div>

                                                                            <div className='sm:w-fit w-full sm:ml-2 ml-0 mb-2'>
                                                                                <Button.Basic
                                                                                    disabled={jobDetails?.isDisputed}
                                                                                    icon={null}
                                                                                    loading={false}
                                                                                    type="primary"
                                                                                    size='small'
                                                                                    text='Raise a dispute'
                                                                                    className={`sm:w-fit w-full px-3 py-5 text-xs disabled-btn`}
                                                                                    onClick={handleDisputePrompt}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                {/* status completed -- dispute btn */}
                                                                {
                                                                    getBookingStatus(jobDetails?.status) == 'completed' && jobDetails?.paymentStatus == 'UNPAID' ?
                                                                        <div className='sm:w-fit w-full sm:ml-2 ml-0  mb-2'>
                                                                            <Button.Basic
                                                                                disabled={jobDetails?.isDisputed}
                                                                                icon={null}
                                                                                loading={false}
                                                                                type="primary"
                                                                                size='small'
                                                                                text='Raise a dispute'
                                                                                className={`sm:w-fit w-full px-3 py-5 text-xs disabled-btn`}
                                                                                onClick={handleDisputePrompt}
                                                                            />
                                                                        </div>
                                                                        : ''
                                                                }
                                                                {
                                                                    getBookingStatus(jobDetails?.status) == 'completed' &&
                                                                    jobDetails?.dispute &&
                                                                    <div className='flex sm:w-fit w-full items-center justify-end sm:ml-3 ml-0 h-[42px]'>
                                                                        <div className="text-center w-full border rounded-md px-2 py-1 border-[#1677ff] mb-2">
                                                                            <span className='text-[#1677ff] text-xs'>
                                                                                {adminActionIdentifier(jobDetails?.dispute?.adminAction)}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        ) : ''}
                                            </div>

                                            <React.Fragment>
                                                {/* previous work */}
                                                {/* <div className='sm:flex hidden sm:justify-start justify-center'>
                                                    {
                                                        jobDetails?.services &&
                                                            jobDetails?.services.length ?
                                                            jobDetails?.services.slice(0, 3).map((service, sIdx) => (
                                                                <span key={'ser1' + sIdx}>
                                                                    <p className='text-gray-500 font-semibold text-xs mb-2' >
                                                                        {service?.name}

                                                                        {sIdx < jobDetails?.services.slice(0, 3).length - 1 &&
                                                                            (<span className='mx-1'>|</span>)}
                                                                        {sIdx == 2 && jobDetails?.services.length > 3 ?
                                                                            (<span className='mr-1'>...</span>) : ''}
                                                                    </p>
                                                                </span>
                                                            ))
                                                            : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )
                                                    }
                                                </div> */}

                                                {/* updated work */}
                                                <div className='flex justify-start mt-2'>
                                                    {
                                                        jobDetails?.services &&
                                                            servicesLength > 0 ? (
                                                            <React.Fragment>
                                                                {
                                                                    jobDetails?.services?.slice(0, 3)?.map((service) => {
                                                                        if (service?.name) {
                                                                            return (
                                                                                <span className='flex gap-1 items-center justify-start'>
                                                                                    <p className='text-gray-500 font-semibold text-xs mb-3 w-fit'>
                                                                                        {service?.name + ','}
                                                                                    </p>
                                                                                </span>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                                {servicesLength > 4 && <span>...</span>}
                                                                {servicesLength > 4 &&
                                                                    (
                                                                        <Tooltip title={getServicesList(jobDetails?.services, false)}>
                                                                            <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                        </Tooltip>
                                                                    )}
                                                            </React.Fragment>
                                                        ) : (
                                                            <small className='text-xs'>Services not available</small>
                                                        )
                                                    }
                                                </div>

                                                {
                                                    (location && location?.pathname.toLowerCase().includes('myjobs')) &&
                                                        getBookingStatus(jobDetails?.status) != 'completed' &&
                                                        getBookingStatus(jobDetails?.status) != 'in-progress' ?
                                                        (
                                                            <div className='sm:flex hidden mb-4 sm:justify-start justify-center'>
                                                                <small className='mr-6 text-[#00B517] font-semibold'>
                                                                    {
                                                                        `${jobDetails?.serviceProvider?.noOfBookingCompleted ?? 0} Job(s) Completed`
                                                                    }
                                                                </small>
                                                                <small className='text-[#FF1D6A] font-semibold'>
                                                                    ( {jobDetails?.distance?.toFixed(2) + ' Miles away'}
                                                                    <span className='ml-1'></span> )
                                                                </small>
                                                            </div>
                                                        ) : ''}
                                            </React.Fragment>

                                            {
                                                location && location?.pathname.toLowerCase().includes('myjobs') &&
                                                    (getBookingStatus(jobDetails?.status) != 'in-progress' &&
                                                        getBookingStatus(jobDetails?.status) != 'completed') ?
                                                    (
                                                        <div className='flex sm:flex-wrap sm:flex-row flex-col pl-0'>
                                                            {/* <div className='bg-[#FEEDBF] sm:ml-2 ml-0 mb-2 p-2 rounded-md'>
                                                                <Link to={`tel:${jobDetails?.serviceUser?.phoneNo}`} className='block h-full'>
                                                                    <div className='flex justify-center items-center h-full'>
                                                                        <FaPhoneAlt className='text-2xl text-white bg-primary p-[5px] rounded-full' />
                                                                        <small className='text-xs ml-2 font-semibold'>Call</small>
                                                                    </div>
                                                                </Link>
                                                            </div> */}
                                                            <div className='ml-0 mb-2 py-[6px] px-2 sm:w-fit w-full bg-[#feedbf] rounded-md'>
                                                                <ChatModal selectedChatMemberData={jobDetails?.serviceUser} />
                                                            </div>

                                                            {/* case: inprogress */}
                                                            {/* view location info */}
                                                            {
                                                                getBookingStatus(jobDetails?.status) == 'in-progress' &&
                                                                (
                                                                    <div>
                                                                        <Button.Basic
                                                                            disabled={false}
                                                                            icon={null}
                                                                            loading={false}
                                                                            type="primary"
                                                                            size='small'
                                                                            text='View Location'
                                                                            className='sm:w-fit w-full px-3 py-5 text-xs'
                                                                            onClick={handleLocationPrompt}
                                                                        />
                                                                    </div>
                                                                )}

                                                        </div>
                                                    ) : ''}
                                        </div>
                                    </div>
                                </div>

                                <hr className='border-dashed border-1 border-gray-200 mb-3' />

                                <div>
                                    <div className='flex sm:flex-row flex-col mb-3 flex-wrap justify-between'>
                                        {jobDetails?.address && (
                                            <div className='flex mr-6 items-center sm:mb-0 mb-2'>
                                                <div className='w-[20px] mr-2'>
                                                    <LuMapPin className='text-2xl text-white bg-primary p-[3px] rounded-full' />
                                                </div>
                                                <small className='text-xs font-md'>{jobDetails?.address}</small>
                                            </div>
                                        )}
                                        {/* {jobDetails?.serviceUser?.phoneNo && (
                                            <div className='flex mr-6 items-center sm:mb-0 mb-2 '>
                                                <Link to={`tel:${jobDetails?.serviceUser?.phoneNo}`} className='flex h-full items-center'>
                                                    <div className='w-[20px] mr-2'>
                                                        <FaPhoneAlt className='text-2xl text-white p-[4px] rounded-full bg-[#3879f0]' />
                                                    </div>
                                                    <small className='text-xs font-md'>{jobDetails?.serviceUser?.phoneNo}</small>
                                                </Link>
                                            </div>
                                        )} */}
                                        {
                                            jobDetails?.createdAt ?
                                                (
                                                    <div className='flex mr-6 items-center sm:mb-0 mb-2'>
                                                        <div className='w-[20px] mr-2'>
                                                            <FaCalendarAlt className='bg-[#fa3434] text-white rounded-full p-[5px] text-2xl' />
                                                        </div>
                                                        <small className='text-xs font-md'>
                                                            {getFormattedDateTime(`${jobDetails?.createdAt}`, 'DD-MM-YYYY HH:mm')}
                                                        </small>
                                                    </div>
                                                ) : ''}

                                        {/* in case of complete booking and isDisputed false, showing updatedAt date and time */}
                                        {
                                            jobDetails?.status == 1 &&
                                                !jobDetails?.isDisputed &&
                                                jobDetails?.updatedAt ?
                                                (
                                                    <div className='flex mr-6 items-center sm:mb-0 mb-2 '>
                                                        <div className='w-[20px] mr-2'>
                                                            <BsCalendarCheckFill className='bg-[#000] text-white rounded-full p-[5px] text-2xl' />
                                                        </div>
                                                        <small className='text-xs font-md'>
                                                            {getFormattedDateTime(`${jobDetails?.updatedAt}`, 'DD-MM-YYYY HH:mm')}
                                                        </small>
                                                    </div>
                                                ) : ''}
                                    </div>

                                    <hr className='border-dashed border-1 border-gray-200 mb-4' />

                                    <div className='mb-4'>
                                        <h6 className='heading-6 font-bold text-sm mb-2'>Services Requested:</h6>
                                        {/* previous work */}
                                        {/* <div className='flex sm:flex-row flex-col'>
                                            {
                                                jobDetails?.services &&
                                                    jobDetails.services.length ? (
                                                    <React.Fragment>
                                                        {jobDetails.services.slice(0, 3).map((service, sIdx) => (
                                                            <div className='flex items-center mb-2 sm:mr-4' key={'ser2' + sIdx}>
                                                                <div className='w-[20px]'>
                                                                    <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                                                </div>
                                                                <small className='font-md text-xs'>{service?.name}</small>
                                                            </div>
                                                        ))}
                                                        {jobDetails?.services?.length > 3 ? (
                                                            <Tooltip title={getServicesList(jobDetails?.services)}>
                                                                <p className='text-xs cursor-pointer'>show all</p>
                                                            </Tooltip>
                                                        ) : ''}
                                                    </React.Fragment>
                                                )
                                                    : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                            }
                                        </div> */}

                                        {/* updated work */}
                                        <div className='mt-4'>
                                            {servicesLength > 0 ?
                                                getLastLayerServices(jobDetails?.services)
                                                :
                                                <small className='text-xs'>Services not available</small>
                                            }
                                        </div>
                                    </div>

                                    {/* {
                                        (getBookingStatus(jobDetails?.status) == 'completed' || getBookingStatus(jobDetails?.status) == 'in-progress')
                                        && jobDetails?.bookingType == 'QUOTE' &&
                                        <div className='mb-4'>
                                            <h6 className='heading-6 font-bold text-sm mb-4'>Services Accepted:</h6>
                                            <div className='flex sm:flex-row flex-col'>
                                                {
                                                    jobDetails?.quotes?.length > 0
                                                        ? (
                                                            <React.Fragment>
                                                                {
                                                                    jobDetails?.quotes?.map((quote) => {
                                                                        if (quote?.status == 'ACCEPTED') {
                                                                            return quote?.services?.length > 0 ? quote?.services.slice(0, 3).map((service, sIdx) => {
                                                                                return (<div className='flex items-center sm:mr-2 mb-2' key={'ser2' + sIdx}>
                                                                                    <div className='w-[20px]'>
                                                                                        <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                                                                    </div>
                                                                                    <small className='font-md text-xs'>{service?.name}</small>
                                                                                </div>)
                                                                            })
                                                                                :
                                                                                'No services available'
                                                                        }
                                                                    })
                                                                }
                                                                {jobDetails?.quotes?.length > 0 ?
                                                                    jobDetails?.quotes?.map((quote) => {
                                                                        if (quote?.status == 'ACCEPTED') {
                                                                            return quote?.services?.length > 3 ? (
                                                                                <Tooltip title={getServicesList(quote?.services)}>
                                                                                    <p className='text-xs cursor-pointer'>show all</p>
                                                                                </Tooltip>
                                                                            ) : ''
                                                                        }
                                                                    })
                                                                    : ''}
                                                            </React.Fragment>
                                                        )
                                                        : (
                                                            <small className='text-xs'>Services not available</small>
                                                        )
                                                }
                                            </div>
                                        </div>
                                    } */}

                                    {jobDetails?.details &&
                                        getBookingStatus(jobDetails?.status) != 'completed' ?
                                        (
                                            <React.Fragment>
                                                <hr className='border-dashed border-1 border-gray-200 mb-4' />
                                                <div className='mb-2'>
                                                    <h6 className='heading-6 font-bold text-sm mb-2'>
                                                        Details of Service
                                                    </h6>
                                                    <small className='text-xs font-md'>{jobDetails?.details}</small>
                                                </div>
                                            </React.Fragment>
                                        ) : ''}

                                    {/* case: pending */}
                                    {/* sp accepts/rejects pending status direct job */}
                                    {
                                        (location && location?.pathname.toLowerCase().includes('myjobs')) &&
                                            (getBookingStatus(jobDetails?.status) == 'pending' || getBookingStatus(jobDetails?.status) == 'admin assigned') &&
                                            !jobDetails?.quote && userId == jobDetails?.serviceProviderId ?
                                            (
                                                <div className='flex flex-col'>
                                                    <div className='flex mb-4'>
                                                        {bookingDecisions.map((decision, dIdx) => (
                                                            <div
                                                                onClick={() => handleJobOfferAsSp(decision?.id)}
                                                                className={`sm:w-fit w-full mr-2 text-xs px-6 py-3 text-white rounded-md cursor-pointer text-center`}
                                                                style={{
                                                                    backgroundColor: decision?.color
                                                                }}
                                                                key={'decision' + dIdx}
                                                            >
                                                                {decision?.label}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {/* {
                                                        profileData?.userDetail?.isEnabled ?
                                                            <p className='text-start text-red-600 mb-2'>Note: {profileData?.userDetail?.percentage}% commission will be charged from the service provider.</p>
                                                            :
                                                            <p className='text-start text-red-600 mb-2'>Note: {calculateCommission(jobDetails?.services)}% commission will be charged based on the service’s percentage.</p>
                                                    } */}
                                                </div>
                                            ) : ''}

                                    {getBookingStatus(jobDetails?.status) == 'rejected' && (
                                        <div>
                                            <h6 className='heading-6 font-bold text-sm mb-2'>Rejection Reason</h6>
                                            <small className='text-xs font-md'>{jobDetails?.reasonOfRejection}</small>
                                        </div>
                                    )}

                                    {getBookingStatus(jobDetails?.status) == 'in-progress' && (
                                        <div>
                                            <hr className='border-dashed border-1 border-gray-200 mb-4' />
                                            <h6 className='heading-6 font-bold text-sm mb-2'>Appointment Date & Time:</h6>
                                            <div className='flex sm:flex-row flex-col sm:items-center mb-2'>
                                                <div className='bg-slate-100 p-4 mr-4 rounded-md flex mb-2'>
                                                    <div className='w-[20px] mr-2'>
                                                        <FaCalendarAlt className='bg-[#fa3434] text-xl text-white p-[3px] rounded-full' />
                                                    </div>
                                                    <small className='text-xs'>
                                                        {formatDateByMonthName(jobDetails?.bookingDate)} -
                                                        {jobDetails?.time}
                                                    </small>
                                                </div>
                                                <div className='flex items-end'>
                                                    <small className='text-xs text-slate-400 mr-1 mb-1'>Accepted Service: </small>
                                                    <p className='font-bold text-lg'>£
                                                        {jobDetails?.quotes?.length && jobDetails?.quotes[0]?.price}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {jobDetails?.quotes.length && jobDetails?.quotes[0] ? (
                                        <React.Fragment>
                                            <hr className='border-dashed border-1 border-gray-200 mb-4' />
                                            <div className='mb-4'>
                                                <h6 className='heading-6 font-bold text-sm mb-2'>
                                                    Additional Info/Note
                                                </h6>
                                                <small className='text-xs font-md'>
                                                    {jobDetails?.quotes[0]?.additionalInfo}
                                                </small>
                                            </div>
                                        </React.Fragment>
                                    ) : ''}

                                    {
                                        jobDetails?.dispute &&
                                        <React.Fragment>
                                            <h6 className='heading-6 font-bold text-sm mb-2'>
                                                Dispute Reason
                                            </h6>
                                            <small className='text-xs font-md'>
                                                {jobDetails?.dispute?.disputeDetail ? jobDetails?.dispute?.disputeDetail : '-'}
                                            </small>
                                        </React.Fragment>
                                    }

                                    {
                                        getBookingStatus(jobDetails?.status) == 'in-progress' &&
                                            jobDetails?.bookingAmendment && jobDetails?.bookingAmendment?.note ? (
                                            <React.Fragment>
                                                <hr className='border-dashed border-1 border-gray-200 mb-4' />

                                                <div className='flex items-end mb-4'>
                                                    <small className='text-xs text-slate-400 mr-1 mb-1'>
                                                        Additional Service Charges:
                                                    </small>
                                                    <p className='font-bold text-lg'>£
                                                        {jobDetails?.bookingAmendment.price}
                                                    </p>
                                                </div>

                                                <hr className='border-dashed border-1 border-gray-200 mb-4' />

                                                <div className='mb-6'>
                                                    <h6 className='heading-6 font-bold text-sm mb-2'>
                                                        Additional Service Changes:
                                                    </h6>
                                                    <small className='text-xs font-md'>
                                                        {jobDetails?.bookingAmendment?.note}
                                                    </small>
                                                </div>
                                            </React.Fragment>
                                        ) : ''}

                                    {/* case: inprogress */}
                                    {/* sp amends an inprogress job */}
                                    {
                                        getBookingStatus(jobDetails?.status) == 'in-progress' && jobDetails?.quotes?.some(quote => quote?.status === 'ACCEPTED' && quote?.serviceProviderId === userId) &&
                                            !jobDetails?.isDisputed &&
                                            !jobDetails?.bookingAmendment ? (
                                            <div className='mb-2'>
                                                <Button.Basic
                                                    onClick={handleJobAmendment}
                                                    disabled={false}
                                                    icon={null}
                                                    loading={false}
                                                    type="primary"
                                                    size='medium'
                                                    text='Amend the booking'
                                                    className='sm:w-fit w-full px-3 p-5 text-xs bg-black'
                                                />
                                            </div>
                                        ) : ''
                                    }

                                    {/* listing commission */}
                                    {
                                        getBookingStatus(jobDetails?.status) == 'in-progress' &&
                                        <>
                                            <hr className='border-dashed border-1 border-gray-200 mb-4' />
                                            <div className='mb-6'>
                                                <h6 className='heading-6 font-bold text-sm mb-2'>
                                                    Commission:
                                                </h6>
                                                {/* {
                                                    profileData?.userDetail?.isEnabled ?
                                                        <p className='text-start text-red-600'>{profileData?.userDetail?.percentage}% commission will be charged from the service provider. Final Earnings: <span className='text-red-500 font-bold text-base underline'>£ {finalPriceAfterExtractingCommission(jobDetails?.quotes?.length > 0 ? jobDetails?.quotes[0]?.price : 0, profileData?.userDetail?.percentage)?.toFixed(2)}</span></p>
                                                        :
                                                        <p className='text-start text-red-600'>{calculateCommission(jobDetails?.services)}% commission will be charged based on the service’s percentage. Final Earnings: <span className='text-red-500 font-bold text-base underline'>£ {finalPriceAfterExtractingCommission(jobDetails?.quotes?.length > 0 ? jobDetails?.quotes[0]?.price : 0, calculateCommission(jobDetails?.services)).toFixed(2)}</span></p>
                                                } */}
                                            </div>
                                        </>
                                    }
                                </div>
                            </Card>
                        ) : (
                            <div className='w-full flex flex-col items-center'>
                                <h5 className='heading-5 font-bold'>Job not found</h5>
                            </div>
                        )}


                        <Modal.Basic
                            open={showModal}
                            onCancel={closeModal}
                            width={400}
                            maskClosable={false}
                        >
                            {modalType == 'quoteInput' ? (
                                <AddSPQuoteForm
                                    type='newQuote'
                                    spLocation={userLocation}
                                    onSuccess={handleSPQuoteFormSuccess}
                                    bookingId={jobDetails?.id}
                                    services={jobDetails?.services}
                                />
                            ) : modalType == 'successAlert' ? (
                                <Alert
                                    onSuccess={closeModal}
                                    onCancel={closeModal}
                                />
                            ) : modalType == 'rejectReasonInput' ? (
                                <RejectionReason
                                    jobId={jobId}
                                    onSuccess={handleBookingRejection}
                                    onCancel={closeModal}
                                />
                            ) : modalType == 'amendJobInput' ? (
                                <AddSPQuoteForm
                                    type='amendQuote'
                                    spLocation={userLocation}
                                    onSuccess={handleQuoteAmendSuccess}
                                    bookingId={jobDetails?.id}
                                    services={jobDetails?.services}
                                />
                            ) : modalType == 'addQuote' && jobDetails.id ? (
                                <AddQuote
                                    qoutesServices={qoutesServices}
                                    bookingId={jobDetails?.id}
                                    onSuccess={handleAddQuoteSuccess}
                                    displayServices={displayQuotesServices}
                                />
                            ) : ''}
                        </Modal.Basic>

                        <Modal.Basic open={prompt} onCancel={() => setPrompt(false)} width={400} maskClosable={false}>
                            <Prompt.Basic
                                message={promptMsg}
                                onChange={handleCloseJobPromptResponse}
                                closeModal={() => setPrompt(false)}
                            />
                        </Modal.Basic>
                    </Col>
                    {
                        disputeModal ? (
                            <DisputeForm
                                isModalOpen={disputeModal}
                                setIsModalOpen={setDisputeModal}
                                formResponseHandler={disputeFormHandler}
                                bookingId={jobDetails?.id}
                                disputedAgainstId={disputedAgainstId}
                                disputedEmail={profileData?.email}
                            />
                        )
                            : ''
                    }
                </Row>

            ) : (
                <h3 className='heading-3 font-bold'>Page Not Found</h3>
            )}
        </React.Fragment>
    )
}

export default JobDetails



const AddSPQuoteForm = ({ onSuccess, spLocation, bookingId, type, services }) => {

    const { submitQuoteAsSP, amendJob } = useJobApi()
    const dispatch = useDispatch()

    const { profileData } = useSelector(state => state?.setting);


    // when a user gets back after connecting a stripe account this is used to call
    // an api for profile detail so wallet info will get added and the text to connect
    // account gets hide.
    useVisibilityCheck();

    const [isStripeConnected, setIsStripeConnected] = useState(true);
    const [commissionValue, setCommissionValue] = useState(() => {
        if (profileData?.userDetail?.isEnabled) {
            return profileData?.userDetail?.percentage
        }
        else {
            return calculateCommission(services)
        }
    });

    useEffect(() => {
        if (!profileData?.wallet?.accountId) {
            setIsStripeConnected(false)
        }
        else {
            setIsStripeConnected(true)
        }
    }, [profileData])

    const [form, setForm] = useState({
        name: 'addSPQuoteForm',
        formFields: [
            {
                name: 'price',
                label: { value: 'Price', classes: '' },
                type: type == 'amendQuote' ? 'text' : 'custom',
                width: { md: 24, sm: 24, xs: 24 },
                component: type == 'amendQuote' ? null : <CustomPriceField commissionPercentage={commissionValue} />,
                classes: '',
                icon: null
            },
            {
                name: 'vatIncluded',
                label: { value: '', classes: '' },
                type: 'radio',
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                options: [
                    { name: 'Price Include VAT', value: 0 },
                    { name: 'Price does not include VAT', value: 1 },
                ],
                defaultValue: 0,
                component: null,
                classes: 'radio-vat flex',
                icon: null,
                design: 'checkbox'
            },
            {
                name: 'date',
                label: { value: 'Date:', classes: '' },
                type: 'datepicker',
                placeholder: '10 June, 2024',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: 'w-full',
                icon: null
            },
            {
                name: 'time',
                label: { value: 'Time:', classes: '' },
                type: 'timepicker',
                placeholder: '12:18PM',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: 'w-full',
                icon: null
            },
            {
                name: 'additionalInfo',
                label: { value: '', classes: '' },
                type: 'textarea',
                placeholder: 'Any Addtional Info/Note',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
        ],
        formValidation: {
            price: Yup.number()
                .required('Price is required')
                .typeError('Price must be a number')
                .min(0, 'Price cannot be negative'),
            time: Yup.string()
                .required('Time is required'),
            additionalInfo: Yup.string()
                .max(1000, 'You cannot enter more than 1000 characters'),
        }
    })


    const handleSubmit = async (values) => {
        try {
            if (type) {
                let response;
                if (type == 'amendQuote') {
                    const { additionalInfo, ...rest } = values;

                    response = await amendJob({ ...rest, note: additionalInfo, bookingId })
                }
                else {
                    const { lat: latitude, lng: longitude, address } = spLocation
                    const date = dayjs(values.date);
                    const formattedDate = date.format('YYYY-MM-DD');
                    const formattedTime = dayjs(values?.time).format('HH:mm');

                    response = await submitQuoteAsSP({
                        bookingId,
                        ...values,
                        date: formattedDate,
                        time: formattedTime,
                        vatIncluded: values.vatIncluded === 0 ? true : false,
                        latitude,
                        longitude,
                        address
                    })
                }
                if (response) {
                    dispatch(setMessage(response?.data?.message))
                    onSuccess()
                }
            }
        } catch (error) {
            console.log(error)
        }
    };

    const submitForm = () => {
        document.querySelector('form#addSPQuoteForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const stripeSetupMutation = useMutation(async () => {
        let res = await axiosInstance.post('/stripe/connected-account', {});
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                window.open(res?.data?.data?.stripeLink?.url, '_blank')
            },
            onError: (error) => {
                dispatch(setError(error.response?.data?.message || 'An error occured'))
            }
        }
    )


    useEffect(() => {
        if (type == 'amendQuote') {
            setForm(null)
            setForm({
                formFields: form?.formFields.filter(e => e.name == 'price' || e.name == 'additionalInfo'),
                formValidation: {
                    price: Yup.number()
                        .required('Price is required')
                        .typeError('Price must be a number')
                        .min(0, 'Price cannot be negative'),
                    additionalInfo: Yup.string()
                        .max(1000, 'You cannot enter more than 1000 characters')
                }
            })
        }
    }, [type])


    return (
        <div className='p-4 text-center'>
            <h6 className='heading-6 font-bold mb-4'>Enter Price & Time</h6>
            <DynamicForm id='addSPQuoteForm' form={form} onSubmit={handleSubmit} />
            <div className="flex justify-end w-full">
                <Button.Basic
                    onClick={submitForm}
                    disabled={!isStripeConnected}
                    icon={null}
                    loading={false}
                    type="primary"
                    size='medium'
                    text='Submit'
                    className='btn-primary w-full'
                />
            </div>
            {
                !isStripeConnected && <p className='my-3'>Please complete your Stripe account setup before submitting.
                    {
                        stripeSetupMutation?.isLoading ?
                            ' Loading ...'
                            :
                            <span className='text-red-400 cursor-pointer' onClick={() => stripeSetupMutation.mutate()}> Click here to get started.</span>
                    }
                </p>
            }
        </div>
    )
}



const Alert = React.memo(() => {
    const navigate = useNavigate()
    return (
        <Card bordered={false} className='rounded-md'>
            <div className='flex flex-col items-center'>
                <img src={successCheck} alt='check-success' className='img-fluid w-[200px]' />
                <h3 className='heading-3 font-bold'>Thank You</h3>
                <p className='mb-2'>Your message has been received and we would be contacting you shortly</p>
                <div className="flex justify-end w-full">
                    <Button.Basic
                        onClick={() => navigate('/')}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='Go to Home'
                        className='btn-primary w-full'
                    />
                </div>
            </div>
        </Card>
    )
})


const RejectionReason = ({ onSuccess, jobId }) => {
    const { acceptRejectJobRequest } = useJobApi()
    const dispatch = useDispatch()
    const form = {
        name: 'rejectReasonForm',
        formFields: [
            {
                name: 'reason',
                label: { value: '', classes: '' },
                type: 'textarea',
                placeholder: 'Enter Details of Rejection',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            }
        ],
        formValidation: {
            reason: Yup.string()
                .required('Reason is required')
                .min(3, 'Reason should be at least 3 characters long')
                .max(500, 'You cannot enter more than 500 characters')
        }
    }

    const handleSubmit = async (values) => {
        try {
            dispatch(setAppLoading(true))
            const response = await acceptRejectJobRequest(jobId, {
                status: 2,
                reasonOfRejection: values?.reason
            })
            if (response) {
                onSuccess(true)
                dispatch(setAppLoading(false))
            }
            else {
                dispatch(setAppLoading(false))
            }

        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    };

    const submitForm = () => {
        document.querySelector('form#rejectReasonForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    return (
        <div className='p-6 text-center w-full'>
            <DynamicForm id='rejectReasonForm' form={form} onSubmit={handleSubmit} />
            <div className="flex justify-end w-full">
                <Button.Basic
                    onClick={submitForm}
                    disabled={false}
                    icon={null}
                    loading={false}
                    type="primary"
                    size='medium'
                    text='Submit'
                    className='btn-primary w-full'
                />
            </div>
        </div>
    )
}




